/* ==========================================================================
   DRENAJE — Animación "typing" en el placeholder de la barra de búsqueda
   Lee los términos desde data-typing-terms (separados por salto de línea o coma).
   Mantiene fijo el prefijo "Buscar.. " y escribe/borra cada término en bucle.
   Se pausa cuando el usuario enfoca o escribe.
   ========================================================================== */
(function () {
  function initTyping(input) {
    if (!input || input.dataset.typingInit === '1') return;
    input.dataset.typingInit = '1';

    var prefix = input.getAttribute('data-typing-prefix') || '';
    var raw = input.getAttribute('data-typing-terms') || '';

    // separa por salto de línea o coma, limpia vacíos
    var terms = raw
      .split(/\r\n|\r|\n|,/)
      .map(function (t) { return t.trim(); })
      .filter(function (t) { return t.length > 0; });

    // sin términos -> deja el placeholder fijo, sin animar
    if (terms.length === 0) {
      input.setAttribute('placeholder', prefix.trim() || input.getAttribute('placeholder') || '');
      return;
    }

    var TYPE_SPEED = 90;     // ms por carácter al escribir
    var ERASE_SPEED = 45;    // ms por carácter al borrar
    var HOLD_FULL = 1300;    // pausa con la palabra completa
    var HOLD_EMPTY = 350;    // pausa antes de la siguiente palabra

    var termIndex = 0;
    var charIndex = 0;
    var erasing = false;
    var paused = false;
    var timer = null;

    function clearTimer() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function render() {
      var word = terms[termIndex].slice(0, charIndex);
      input.setAttribute('placeholder', prefix + word);
    }

    function tick() {
      if (paused) return;

      if (!erasing) {
        if (charIndex < terms[termIndex].length) {
          charIndex++;
          render();
          timer = setTimeout(tick, TYPE_SPEED);
        } else {
          erasing = true;
          timer = setTimeout(tick, HOLD_FULL);
        }
      } else {
        if (charIndex > 0) {
          charIndex--;
          render();
          timer = setTimeout(tick, ERASE_SPEED);
        } else {
          erasing = false;
          termIndex = (termIndex + 1) % terms.length;
          timer = setTimeout(tick, HOLD_EMPTY);
        }
      }
    }

    function start() {
      if (paused) return;
      clearTimer();
      timer = setTimeout(tick, 600);
    }

    function pause() {
      paused = true;
      clearTimer();
    }

    function resume() {
      // solo reanuda si el campo está vacío y sin foco
      if (input.value && input.value.length > 0) return;
      if (document.activeElement === input) return;
      paused = false;
      // restaura el placeholder a estado limpio antes de seguir
      charIndex = 0;
      erasing = false;
      render();
      start();
    }

    // El usuario interactúa -> pausa
    input.addEventListener('focus', pause);
    input.addEventListener('input', pause);

    // Sale del campo y está vacío -> reanuda
    input.addEventListener('blur', function () {
      setTimeout(resume, 200);
    });

    // Pausa cuando la pestaña no está visible (ahorra recursos)
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pause();
      } else if (!input.value && document.activeElement !== input) {
        paused = false;
        start();
      }
    });

    start();
  }

  function initAll() {
    var inputs = document.querySelectorAll('[data-typing-input]');
    inputs.forEach(initTyping);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-inicializa si el header se recarga vía el editor de temas de Shopify
  document.addEventListener('shopify:section:load', initAll);
})();
